import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth'; //TO DO try logging in with this line commented out
import { GoogleAuthProvider } from 'firebase/auth';
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "semantic-ui-css/semantic.min.css";
import "./index.css";

const firebaseConfig = {
  apiKey: "AIzaSyCDkIdL_jcbQSIyd4KTCPvIL3pqkyleqXU",
  authDomain: "computablepublishing-users.firebaseapp.com",
  databaseURL: "https://computablepublishing-users.firebaseio.com",
  projectId: "computablepublishing-users",
  storageBucket: "computablepublishing-users.firebasestorage.app",
  messagingSenderId: "946549403314",
  appId: "1:946549403314:web:f50df1a462b7331b12e3ab",
  measurementId: "G-LG0YHK7MH9"
};

firebase.initializeApp(firebaseConfig);
let firebaseGoogleProvider = new GoogleAuthProvider();
firebaseGoogleProvider.setCustomParameters({ prompt: 'select_account' });
firebaseGoogleProvider.addScope('profile');
firebaseGoogleProvider.addScope('email');
let firebaseEmailAuthProvider = () => { };

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App firebaseGoogleProvider={firebaseGoogleProvider} firebaseEmailAuthProvider={firebaseEmailAuthProvider} />
      </Provider>
    </React.StrictMode>,
  )
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();